<template>
    <div @click="openSettings" class="dotscontrol">
        <div class="dotscontrol_dots">
            <span class="dotscontrol_dots__span"></span>
        </div>
        <div v-if="open" class="dotscontrol_control">
            <a @click="edit">EDIT</a>
            <a @click="remove">DELETE</a>
        </div>
    </div>
</template>

<script>
import {bus} from '../bus';
import axios from "axios";
export default {
    props: ['link', 'id'],
    data() {
        return{
            open: false,
            data: []
        }
    },
    methods: {
        openSettings(){
            this.open = true;
        },
        edit(){
            bus.$emit('openpopup', {
                open: true,
                type: 'addcategory'
            })
        },
        remove(){

            let token = document.head.querySelector('meta[name="csrf-token"]');
            window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;

            axios.delete('/'+this.link+'/'+this.id)
            .then(function (response) {
                console.log('remove' , response.data);

                if(response.data === 'success'){
                    bus.$emit('update_category', true);
                }

            }).catch(function (error) {
                // handle error
                console.log(error);
            })

        }
    },
    mounted(){
        window.addEventListener('click', (e) => {

            if(e.srcElement.classList.contains("dotscontrol") || e.srcElement.classList.contains("dotscontrol_dots") || e.srcElement.classList.contains("dotscontrol_dots__span")){
                // this.open = true;
            }else{
                this.open = false;
            }

        });
    }
}
</script>

<style lang="scss" scoped>

</style>
